module.exports = __webpack_public_path__ + "static/media/arrow_down_white.6f92aab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_down_white.png
// module id = 1071
// module chunks = 0